import { useEffect } from "react";
import { useAuth } from "react-oidc-context";

export function RequireAuth({ children }: { children: JSX.Element }) {
    const auth = useAuth();

    useEffect(() => {
        if (!auth.isLoading && !auth.isAuthenticated) {
            auth.signinRedirect();
        }
    }, [auth]);

    if (auth.isLoading) {
        return <div>Loading auth...</div>;
    }

    if (!auth.isAuthenticated) {
        return null;
    }

    return children;
}